export default __webpack_public_path__ + "static/media/Door_sensor.e486c3c6.svg";